import type { TcfApi } from '../../types/global';
import { resolveWithTimeout } from '../../utils/async';

const getTcfConsentString = (tcfapi: TcfApi) => {
  return new Promise<string>((resolve) => {
    tcfapi('addEventListener', 2, (tcdata, success) => {
      if (!success) {
        // callback could not be registered as a listener
        resolve('');
      } else if (
        tcdata.eventStatus === 'tcloaded' ||
        tcdata.eventStatus === 'useractioncomplete'
      ) {
        resolve(tcdata.tcString ?? '');

        tcfapi('removeEventListener', 2, () => {}, tcdata.listenerId);
      }
    });
  });
};

export const getTcfConsentKeywords = async (): Promise<
  Record<string, string>
> => {
  if (!window.__tcfapi) {
    return { gdpr: '0' };
  }

  const consent = await resolveWithTimeout({
    promise: getTcfConsentString(window.__tcfapi),
    fallback: '',
    timeout: 2500,
  });

  return consent ? { gdpr: '1', gdpr_consent: consent } : { gdpr: '0' };
};
